var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66675 10.6667V11.3333C2.66675 11.8638 2.87746 12.3725 3.25253 12.7475C3.62761 13.1226 4.13632 13.3333 4.66675 13.3333H11.3334C11.8638 13.3333 12.3726 13.1226 12.7476 12.7475C13.1227 12.3725 13.3334 11.8638 13.3334 11.3333V10.6667M10.6667 5.33333L8.00008 2.66666M8.00008 2.66666L5.33341 5.33333M8.00008 2.66666V10.6667",
    stroke: "#09090B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadOutline);
export default __webpack_public_path__ + "static/media/UploadOutline.56b5f9046d477c7e75c0d8ecdcf41ab1.svg";
export { ForwardRef as ReactComponent };